import Report from '@/models/Report'
import Api from '@/services/api'
import { each, find, findIndex } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
  },

  actions: {
    async getReports({ commit }, params) {
      const query = Report.page(params.page || 1).include(
        'reporter',
        'reason',
        'attachments'
      )
      if (params.tag) {
        query.where('tag', params.tag)
      }
      if (params.reason) {
        query.where('reason', params.reason)
      }
      if (params.date_reported) {
        query.where('date_reported', params.date_reported)
      }
      if (params.type) {
        query.where(params.type, 1)
      }
      if (params.model) {
        query.where(params.model, 1)
      }
      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()
      commit('setReportsList', res.data)
      commit('setReportsListMeta', res.meta)
    },

    async deleteReportedPost({ commit }, params) {
      await Api.delete(`admin/reports/posts/${params.reportableId}`)
      commit('setReportableDeletedAt', params.reportId)
    },

    async deleteReportedComment({ commit }, params) {
      await Api.delete(`admin/reports/comments/${params.reportableId}`)
      commit('setReportableDeletedAt', params.reportId)
    },

    async keepReportedContent({ commit }, params) {
      await Api.put(`admin/reports/keep/${params.reportId}`)
      commit('setReportIsKept', params.reportId)
    },

    async exportToExcel({ commit }, params) {
      let endpoint = 'admin/reports/export'

      if (params.search) {
        endpoint = `${endpoint}?search=${params.search}`
      }
      if (params.type) {
        let op = params.search ? '&' : '?'
        endpoint = `${endpoint}${op}filter[${params.type}]=1`
      }
      if (params.model) {
        let op = params.search || params.type ? '&' : '?'
        endpoint = `${endpoint}${op}filter[${params.model}]=1`
      }
      if (params.tag) {
        let op = params.search || params.type || params.model ? '&' : '?'
        endpoint = `${endpoint}${op}filter[tag]=${params.tag}`
      }
      if (params.reason) {
        let op =
          params.search || params.type || params.model || params.tag ? '&' : '?'
        endpoint = `${endpoint}${op}filter[reason]=${params.reason}`
      }
      if (params.date_reported) {
        let op =
          params.search ||
          params.type ||
          params.model ||
          params.tag ||
          params.reason
            ? '&'
            : '?'
        endpoint = `${endpoint}${op}filter[date_reported]=${params.date_reported}`
      }

      const file = await Api.get(endpoint, {
        responseType: 'blob',
      })
      return file
    },
  },

  mutations: {
    setReportsList(state, reports) {
      each(reports, (report) => {
        const exist = find(state.list, { id: report.id })
        if (!exist) {
          state.list.push(new Report(report))
        }
      })
    },

    clearReportsList(state) {
      state.list = []
    },

    setReportsListMeta(state, meta) {
      state.listMeta = meta
    },

    setReportableDeletedAt(state, reportId) {
      const index = findIndex(state.list, { id: reportId })
      state.list[index].reportable.deleted_at = new Date()
    },

    setReportIsKept(state, reportId) {
      const index = findIndex(state.list, { id: reportId })
      state.list[index].is_denied = true
    },
  },
}
